<template>
  <div data-v-f4f364e8="" data-v-2ac6a5fc="" class="modifyPhone member">
    <form data-v-f4f364e8="">
      <div data-v-f4f364e8="" class="list">
        <!---->
        <div data-v-f4f364e8="" class="form-group">
          <label data-v-f4f364e8="">手机号</label>
          <div data-v-f4f364e8="" class="input-group">
            <input data-v-f4f364e8="" v-model="mobile" size="12" maxlength="12" placeholder="请输入手机号" type="text" />
          </div>
        </div>
        <!-- <div data-v-f4f364e8="" class="form-group">
					<label data-v-f4f364e8="">验证码</label>
					<div data-v-f4f364e8="" class="input-group">
						<input data-v-f4f364e8="" placeholder="请输入验证码" size="12" maxlength="6" type="text">
						<a data-v-f4f364e8="" class="link active">发送验证码 </a></div>
				</div> -->
      </div>
      <p data-v-f4f364e8="">无法修改手机号码，<a data-v-f4f364e8="" @click="$parent.openKefu">联系客服</a></p>
      <a data-v-f4f364e8="" class="form-button" @click="isOk">确认</a>
    </form>
    <div data-v-f4f364e8="" class="pay-dialog" style="display: none">
      <div data-v-f4f364e8="" slot="alertContent" class="pay-password">
        <div data-v-f4f364e8="" class="pay-password__header">提示<i data-v-f4f364e8="" class="pay-password__close"></i></div>
        <p data-v-f4f364e8="" class="pay-password__title"><span data-v-f4f364e8=""></span></p>
        <div data-v-f4f364e8=""><a data-v-f4f364e8="" href="javascript:void (0);" class="pay-password__button"> 联系客服 </a></div>
      </div>
    </div>
    <div data-v-f4f364e8="" class="pay-dialog unbind-pwd-dialog" style="display: none">
      <div data-v-f4f364e8="" slot="alertContent" class="pay-password">
        <div data-v-f4f364e8="" class="pay-password__header">提示<i data-v-f4f364e8="" class="pay-password__close"></i></div>
        <i data-v-f4f364e8="" class="unbind-waring"></i>
        <p data-v-f4f364e8="" class="pay-password__title"><span data-v-f4f364e8="">为确保您的账户安全，请联系客服修改</span></p>
        <div data-v-f4f364e8=""><a data-v-f4f364e8="" href="javascript:void (0);" class="pay-password__button"> 联系客服 </a></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modifyPhone',
  data() {
    return {
      mobile: null,
    };
  },
  created() {
    let that = this;
    that.mobile = that.$store.state.userInfo.mobile
  },
  methods: {
    isOk() {
      let that = this;
      let url = '/api/updateuserinfo';
      let info = {};
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      //手机号
      info.mobile = that.mobile;
      info.birthday = userInfo.birthday;
      info.email = userInfo.email;
      let regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(that.mobile)) {
        that.$parent.showTost(0, '请输入正确手机号');
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.post(url, info).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();

        }
        if (res.code == 200) {
          that.$parent.showTost(1, res.message);
          that.$parent.getUserInfos();
        }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-f0bd1cea.3921d552.css';
</style>



// WEBPACK FOOTER //
// src/components/main/modifyPhone.vue